export const DEFAULT_FORMATING = 'MMM d,yyyy'
export const ONE_MONTH = 1
export const TWO_MONTHS = 2
